import { DATA_TOOL_LIMITS, normalizeText, parseCsv, validateTextSource } from "./data-tool-core.js";

export function csvToJson(source, { headerRow = true, detectTypes = false, indentation = 2 } = {}) {
  const text = normalizeText(source);
  const validation = validateTextSource(text, "CSV");
  if (validation) return { error: validation, output: "" };
  try {
    const rows = parseCsv(text);
    if (!rows.length || rows.length === 1 && rows[0].every(value => !value))
      return { error: "CSV does not contain any rows.", output: "" };
    const width = Math.max(...rows.map(row => row.length));
    const normalizedRows = rows.map(row => [...row, ...Array(Math.max(0, width - row.length)).fill("")]);
    let outputValue;
    if (headerRow) {
      const headers = normalizedRows[0].map(value => value.trim());
      if (headers.some(value => !value)) return { error: "Every header cell needs a name.", output: "" };
      if (new Set(headers).size !== headers.length) return { error: "CSV header names must be unique.", output: "" };
      outputValue = normalizedRows.slice(1).map(row =>
        Object.fromEntries(headers.map((header, index) => [header, convertCell(row[index], detectTypes)])));
    } else {
      outputValue = normalizedRows.map(row => row.map(value => convertCell(value, detectTypes)));
    }
    const spacing = Number(indentation) === 4 ? 4 : 2;
    const output = JSON.stringify(outputValue, null, spacing);
    if (output.length > DATA_TOOL_LIMITS.outputCharacters)
      return { error: "Generated output exceeds the 8,000,000 character limit.", output: "" };
    return {
      error: "",
      output,
      records: headerRow ? Math.max(0, normalizedRows.length - 1) : normalizedRows.length,
      columns: width
    };
  } catch (error) {
    return { error: error?.message || "Invalid CSV. Check quoted fields and row structure.", output: "" };
  }
}

function convertCell(value, detectTypes) {
  if (!detectTypes) return value;
  const trimmed = value.trim();
  if (trimmed === "true") return true;
  if (trimmed === "false") return false;
  if (trimmed === "null") return null;
  if (/^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:e[+-]?\d+)?$/i.test(trimmed)) {
    const number = Number(trimmed);
    if (Number.isSafeInteger(number) || !Number.isInteger(number)) return number;
  }
  return value;
}
